import { render, staticRenderFns } from "./ElMainTable.vue?vue&type=template&id=56600a14&scoped=true"
import script from "./ElMainTable.vue?vue&type=script&lang=js"
export * from "./ElMainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56600a14",
  null
  
)

export default component.exports